import { toast } from 'vue3-toastify';
import {
  AvailablePromotionItemDto,
  CheckPromotionFulfillmentRequestV2Dto,
  CheckPromotionRequestV2Dto,
  PromotionItemDto,
  SearchPromotionRedeemableRequestDto,
} from '~/contract/dto/PromotionRelated.dto';
import { PromotionType } from '~/contract/enum/PromotionRelated.enum';
import { PageMeta } from '~/contract/vo/SearchRelated.vo';
import ApiService from '~/service/ApiService';
import { useCheckoutStore } from './checkout';

export const usePromotionStore = defineStore('promotion', {
  state: () => ({
    promotionList: [] as AvailablePromotionItemDto[],
    redeemablePromotionList: [] as AvailablePromotionItemDto[],
    redeemedPromotionList: [] as AvailablePromotionItemDto[],
    redeemablePromotionResult: {
      currentPage: 1,
      itemCount: 0,
      itemPerPage: 0,
      totalItemCount: 0,
      totalPage: 1,
    } as PageMeta,
    loading: false,
    popupConfig: null as any,
  }),
  actions: {
    async fetchAvailablePromotion() {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.get('/api/v1', 'promotion', true, {
        key: `promotion-${new Date().getTime()}`
      });
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value && data.value.data) {
        const response = data.value.data as Array<AvailablePromotionItemDto>;
        this.promotionList = response;
      }
    },
    async fetchPromotionEligibility(request: CheckPromotionRequestV2Dto) {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.query('/api/v2/promotion/eligibility', request, true);
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value && data.value.data) {
        const response = data.value.data as PromotionItemDto;
        useCheckoutStore().selectedPromotion.set(response.promotionType, response);
      }
    },
    async fetchPromotionEligibilityFulfill(humanPreOrderId: string, request: CheckPromotionFulfillmentRequestV2Dto) {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.post(`/api/v2/promotion/eligibility/${humanPreOrderId}/fulfillment`, request, true);
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value && data.value.data) {
        const response = data.value.data as PromotionItemDto;
        useCheckoutStore().selectedPromotion.set(response.promotionType, response);
      }
    },
    async fetchPromotionRedeemableList(request: SearchPromotionRedeemableRequestDto) {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.query('/api/v2/promotion/redeemable', request, true);
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value && data.value.data) {
        const response = data.value.data as Array<AvailablePromotionItemDto>;
        this.redeemablePromotionList = response;
        this.redeemablePromotionResult = data.value.meta as PageMeta;
      }
    },
    async fetchPromotionRedeemableSingle(humanCode: string) {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.get('/api/v2/promotion/redeemable', humanCode, false);
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value && data.value.data) {
        const response = data.value.data as AvailablePromotionItemDto;
        return response;
      }
    },
    async fetchPromotionRedeemedList() {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.get('/api/v2/promotion', 'redeemed', true);
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value && data.value.data) {
        const response = data.value.data as Array<AvailablePromotionItemDto>;
        this.redeemedPromotionList = response;
      }
    },
    async doRedeemPromotion(humanCode: string) {
      this.loading = true;
      const { data, pending, error, refresh }: any = await ApiService.post(`/api/v2/promotion/redeemable/${humanCode}`, {}, true);
      this.loading = pending.value;
      if (error.value) {
        this.loading = false;
        throw error.value;
      }
      if (data.value) {
        toast.success(data.value.message, {
          position: 'top-right',
        });
      }
    },
    async fetchPopupConfig() {
      const { data, pending, error, refresh }: any = await ApiService.get('/api/v1', 'promotion/popup-config', true, {
        key: `popup-config-${new Date().getTime()}`
      });
      if (data.value && data.value.data) {
        this.popupConfig = data.value.data;
      }
    },
    getPromotionList(promotionTypes?: Array<PromotionType>) {
      if (!promotionTypes) {
        return this.promotionList;
      }
      return this.promotionList.filter((item) => promotionTypes.includes(item.promotionType));
    },
  },
});
